
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/metiers/[slug]",
      function () {
        return require("private-next-pages/metiers/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/metiers/[slug]"])
      });
    }
  